
import { Link, useMatch } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import { Spinner } from "react-bootstrap";

export default () => {
  const { authState, authDispatch,handleError } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState([]);
  henceforthApi.setToken(authState.access_token);

  const initialiseData = async () => {
    try {
      setLoading(true)
      let apiRes = await henceforthApi.Policies.all();
      setState(apiRes);
      // console.log("content Data", apiRes);
      setLoading(false)
    } catch (error) { 
      handleError(error)
      setLoading(false)
    }
  };
  useEffect(() => {
    initialiseData();
  }, []);

  return ( 
    <>
    {loading ? <Spinner/> :
    <div className="ibox animated fadeInRight">
      <div className="ibox-title">
        <h5>Policies</h5>
        {/* <div className="d-flex justify-content-end">
          <Link
            to={`/policies/add`}
            className="btn btn-primary button h-100"
          >
            Add
          </Link>
        </div> */}
      </div>
      <div className="ibox-content ">
        <div className="table-responsive">
          <table className="table table-striped" style={{ whiteSpace: 'nowrap' }}>
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Title</th>
                <th>Content</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {state.map((res, index) => {
                // console.log(res);
                return (
                  <tr key={res._id}>
                    <td>{index + 1}.</td>
                    <td>{res.type == "TERM_AND_CONDITION" ? "TERMS_AND_CONDITIONS".split("_").join(" ") :res.type.split("_").join(" ")}</td>
                    <td >
                      <div
                        className="userMessageLength align-items-center"
                        dangerouslySetInnerHTML={{
                          __html:
                            res.description?.length > 250 
                              ? res.description?.slice(0,250) + "...."
                              : res.description
                        }}
                      ></div>
                    </td>
                    <td>
                      <div className="text-center">
                        <Link
                          to={`/policies/${res._id}/${res.type}`}
                          className="btn-white btn btn-xs me-2 "
                        >
                          <i className="fas fa-eye me-1"></i>View
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div> } </>
  );
};
